export default __webpack_public_path__ + "static/media/game-night.f2591616.png";